import { browserHistory } from 'react-router';
import { actions as logoutActions } from '../redux/auth/logout';
import { LOGIN } from '../constants/routes';
import {
  AUTHENTICATION_TOKEN,
  KICKED_TO_LOGIN,
  LOGGED_IN,
} from '../constants/storageKeys';
import { checkIsPaperworkRoute } from './paperwork';

const handleBgTabState = (e, focused, store) => {
  const { isPaperworkRoute } = checkIsPaperworkRoute();

  // Paperwork tabs use a separate paperworkToken and must not react to
  // regular-app auth events — and regular-app tabs must not react to
  // paperwork auth events. Each session type manages itself independently.
  if (isPaperworkRoute) {
    return;
  }

  const authTokenRemoved =
    e.key === AUTHENTICATION_TOKEN && !!e.oldValue && e.oldValue !== e.newValue;

  // Set regardless of focus: a tab that had its auth token wiped by another
  // tab must not reload when that other tab later logs in, even if this tab
  // was focused (and therefore didn't dispatch logout) at the time of removal.
  if (authTokenRemoved) {
    sessionStorage.setItem(KICKED_TO_LOGIN, 'true');
  }

  // prevent event firing in current active tab [IE]
  if (!focused) {
    if (authTokenRemoved) {
      store.dispatch(logoutActions.clear());
      browserHistory.push(LOGIN);
    }

    const loggedIn =
      e.key === LOGGED_IN &&
      e.newValue &&
      e.newValue.length &&
      JSON.parse(e.newValue) &&
      (!e.oldValue || !e.oldValue.length || !JSON.parse(e.oldValue));

    if (loggedIn && !sessionStorage.getItem(KICKED_TO_LOGIN)) {
      window.location.reload();
    }
  }
};

export default handleBgTabState;



// WEBPACK FOOTER //
// ./src/utils/handleBgTabState.js